/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Control from '../Control/Control';
import './Spinner.css';

/**
 * Represents the spinner component.
 */

export default class Spinner extends Control {
    
    /** Color types. */
    static get COLOR() { return {
        COLOR:      'color',
        WHITE:      'white'
    };}

    /**
     * Properties.
     */

    static propTypes = {
        label:      PropTypes.string,
        size:       PropTypes.number,
        wide:       PropTypes.number,
        color:      PropTypes.string,
        modal:      PropTypes.bool
    }

    /**
     * Default property values.
     */

    static defaultProps = {
        size:       32,
        wide:       4,
        color:      Spinner.COLOR.COLOR
    }      
   
    /** 
     * Spinner renderer.
     */

    render() {

        // Spinner with label

        let spinner = () => {
            return (
                <div className="horizontal center" style={ this.props.modal ? {} : this._getStyle() }>
                    <svg className="spinner-circular" viewBox="20 20 40 40" style={{ width: this.props.size + 'px' }}>
                        <circle className={ 'spinner-path ' + (this.props.color === Spinner.COLOR.WHITE ? 'spinner-white' : 'spinner-color') } cx="40" cy="40" r="18" fill="none" strokeWidth={ this.props.wide || 4 } strokeMiterlimit="10"/>
                    </svg>
                    { this.props.label &&
                        <div className={(this.props.color === Spinner.COLOR.WHITE ? 'spinner-label-white' : 'spinner-label-color')} style={{ marginLeft: (this.props.size * 0.4) + 'px', fontSize: parseInt(this.props.size * 0.46, 10)}}>{this.props.label}</div>
                    }
                </div>
            );
        };

        // Rendering
        
        return (
            <div>
                { this.props.modal ?
                    <div>
                        <div className="spinner-modal-background fit"></div>
                        <div className="spinner-modal horizontal vertical center center-justified">{spinner()}</div>
                    </div>
                : spinner() }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js